var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"redactorxContainer",staticClass:"redactorx-container"},[_c('textarea',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"redactorx",attrs:{"name":_vm.name},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }